// extracted by mini-css-extract-plugin
export default {"container":"title_container__p69Mt","title":"title_title__R7Ez5","tools":"title_tools__O8e-2","row":"title_row__kitVF"};